import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Avatar: ComponentStyleConfig = {
  parts: ['Avatar', 'AvatarBadge'],
  baseStyle: () => {
    return {
      Avatar: {},
      AvatarBadge: { boxSize: '1.25em', bg: 'green.500' },
    };
  },
};

export default Avatar;
